import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class GrupoUsuarioService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'grupo-usuario');
  }

  indexFiltered(usuario_interno: boolean): Observable<any> {
    const params = new HttpParams().set('usuario_interno', usuario_interno.toString());
    return this.http.get(`${this.url_base}/${this.prefixo}`, { params });
  }

}
